<template>
    <div class="categories-selector">
        <CategoryPill
            category="all"
            :selected="!route.query.category"
            :link="`${pagePathWithoutPagination}${locationQueryToQueryString({...query, category: [], ...(currentTab && {type: currentTab})})}`"
        />
        <CategoryPill
            v-for="category in resourceCategories"
            :key="category.uid"
            :category="category.uid"
            :label="category.data.name || ''"
            :selected="route.query.category === category.uid"
            :link="`${pagePathWithoutPagination}${locationQueryToQueryString({
                ...query,
                category: category.uid,
                ...(currentTab && {type: currentTab}),
            })}`"
        />
        <CategoryPill
            v-for="category in categories"
            :key="category"
            :category="category"
            :selected="route.query.category === category"
            :link="`${pagePathWithoutPagination}${locationQueryToQueryString({...query, category, ...(currentTab && {type: currentTab})})}`"
        />
    </div>
</template>
<script setup lang="ts">
    import type {ResourceCategoryDocument} from '@prismicio-types';
    import {useRoute} from '@typed-router';
    import {computed, createContentHelpers, useAsyncData} from '#imports';
    import CategoryPill from '~/components/CategoryPill.vue';
    import usePrismicSearch from '~/composables/content/usePrismicSearch';
    import {CATEGORIES} from '../app/keys';

    defineProps<{currentTab?: string}>();

    const route = useRoute('resources-articles-page');
    const {
        path,
        params: {page},
        query,
    } = route;
    const pagePathWithoutPagination = page ? path.split('/').slice(0, -1).join('/') : path;
    const {locationQueryToQueryString} = createContentHelpers();

    const {data} = await useAsyncData(
        'resourcesCategories',
        () => usePrismicSearch<ResourceCategoryDocument>({type: 'resourceCategory', pageSize: 100}),
        {deep: true},
    );

    const resourceCategories = computed((): ResourceCategoryDocument[] => data.value?.results || []);
    const categories = computed(() => {
        const resourceCategoryUids = new Set(resourceCategories.value.map((category) => category.uid));
        return CATEGORIES.filter((category) => {
            return !resourceCategoryUids.has(category.toLowerCase());
        });
    });
</script>

<style lang="scss">
    .categories-selector {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
    }
</style>
